import React from "react";
import { FlexColumn, InlineBlock } from "../Common/__styles__/Layout";
import { ScreenOnly } from "../Common/__styles__/ScreenOnly";
import { Label, lineHeights, TextSize } from "../Common/__styles__/Typography";
import { MarkdownTooltip } from "../Common/Tooltip";
import { Body, BodyType } from "../Common/Typography";
import { LabelMeta, Required } from "./__styles__/Label";

export type LabelProps = {
  description?: Maybe<string>;
  disabled?: boolean;
  htmlFor?: string;
  required?: boolean;
  size?: TextSize;
  style?: React.CSSProperties;
  text: string;
  tooltip?: string;
  type?: BodyType;
  compact?: boolean;
} & Parameters<typeof Label>["0"];

export default ({
  description,
  disabled = false,
  required = false,
  size = "default",
  text,
  tooltip,
  type = "emphasis",
  compact = false,
  htmlFor,
  ...props
}: LabelProps) => {
  const hasDescription = !!description;
  const hasRequired = !!required;
  const hasTooltip = !!tooltip;
  const hasLabelMeta = hasRequired || hasTooltip;

  return (
    <Label
      hasTooltip={hasTooltip}
      size={size}
      type={type}
      compact={compact}
      htmlFor={htmlFor}
      {...props}
    >
      <FlexColumn gap="xs">
        <InlineBlock style={{ lineHeight: lineHeights.s }}>
          {text.trim()}
          {hasLabelMeta && (
            <LabelMeta>
              {hasRequired && <Required>*</Required>}
              {hasTooltip && <LabelTooltip text={tooltip} />}
            </LabelMeta>
          )}
        </InlineBlock>
        {hasDescription && (
          <ScreenOnly>
            <Body
              size={"small"}
              type="regular"
              color={disabled ? "contentDisabled" : "contentSecondary"}
            >
              {description}
            </Body>
          </ScreenOnly>
        )}
      </FlexColumn>
    </Label>
  );
};

const LabelTooltip = ({ text }: { text: string }) => {
  return <MarkdownTooltip tooltipText={text} place="right" />;
};
